<template>
  <div class="edit-component" :class="editcompclasses">
    <p class="edit-component__title">{{ title }}</p>
    <label class="switch" :class="classes">
      <input
        class="switch__input"
        type="checkbox"
        :checked.prop="isChecked"
        name="name"
        @click="onClick"
      />

      <div class="switch__thumb"></div>

      <div class="switch__track"></div>
    </label>

    <div class="edit-component__photo" v-if="type === 'Profile'">
      <img :key="avatar" class="avatar-img" :src="avatar" alt="" />
    </div>

    <a
      class="edit-component__link"
      :href="link"
      @click.prevent="$router.push(link)"
      >Редактировать</a
    >
    <div class="edit-component__tip-wrapper">
      <CTooltip :action="show_tooltip" :position="tooltip_position"
        >{{ tooltip }}
      </CTooltip>
      <div class="edit-component__tip" @click="showTooltip">
        <img src="../assets/img/question.svg" width="28" height="28" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CTooltip from "../components/forms/CTooltip";

export default {
  name: "EditComponent",
  components: { CTooltip },
  props: {
    title: String,
    type: String,
    link: String,
    value: {
      required: true
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    }
  },

  data() {
    return {
      isChecked: this.value,
      show_tooltip: false,
      tooltip_position: "right",
      tooltip: "",
      tooltips: [
        { label: "Profile", tooltip: "" },
        {
          label: "Background",
          tooltip:
            "Фон страницы персонализирует вашу страницу и сделает привлекательной для клиентов."
        },
        {
          label: "Products",
          tooltip: this.$store.state.userTypes.vip
            ? "Укажите продукты, которые вы рекомендуете посетителям вашей страницы."
            : "Укажите продукты, которые вы представляете, чтобы клиентам было проще ориентироваться."
        },
        {
          label: "Achievements",
          tooltip:
            "Укажите курсы, которые вы прошли, и области, в которых вы стали экспертом. Люди должны знать о вашем профессионализме."
        },
        {
          label: "Events",
          tooltip:
            "Укажите мероприятия Amway, которые вы советуете своим друзьям и клиентам. Эти события могут быть полезны вашей аудитории."
        },
        {
          label: "Certificates",
          tooltip:
            "Загрузите фотографии или сканы сертификатов, которые подтверждают ваши профессиональные достижения."
        },
        {
          label: "SocialLinks",
          tooltip:
            "Добавьте ссылки на ваши социальные сети, чтобы партнеры и клиенты могли вас легко найти."
        },
        { label: "Template", tooltip: "" }
      ]
    };
  },

  mounted() {
    this.fillTooltips();
  },

  computed: {
    ...mapGetters(["getComponentByName"]),
    classes() {
      return [{ "is-checked": this.isChecked }];
    },
    editcompclasses() {
      return [
        { "edit-component--active": this.isChecked },
        {
          "edit-component--profile":
            this.type === "Profile" || this.type === "Template"
        }
      ];
    },
    avatar() {
      const { content } = this.getComponentByName("Profile");
      if (content.avatar) {
        let str = (process.env.VUE_APP_API_ROOT + content.avatar).replace(
          "api",
          ""
        );
        return str;
      }
      return require("@/assets/img/avatar-dark.svg");
    }
  },
  watch: {
    value() {
      this.isChecked = this.value;
    }
  },

  methods: {
    onClick(e) {
      this.isChecked = e.target.checked;
      this.$emit("input", e.target.checked ? this.trueValue : this.falseValue);
    },
    fillTooltips() {
      this.tooltip = this.tooltips.find(i => i.label === this.type).tooltip;
    },
    showTooltip() {
      this.show_tooltip = !this.show_tooltip;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars.scss";

.avatar-img {
  width: 108px;
  height: 108px;

  border-radius: 50%;
}

.edit-component {
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  max-width: 360px;
  height: 160px;
  padding: 30px 22px 22px 22px;

  border-radius: 12px;
  border: 1px solid #cccccc;

  &--active {
    background-color: #26cc73;
  }

  &--active &__title {
    color: #fff;
  }

  &__title {
    max-width: 245px;
    margin: 0;

    font-size: 24px;
    line-height: 29px;
    font-weight: 600;
    color: #303333;
  }

  &__photo {
    position: absolute;
    top: 50%;
    right: 22px;

    display: none;

    width: 108px;
    height: 108px;

    border-radius: 50%;
    transform: translateY(-50%);
  }

  &--profile &__photo {
    display: block;
  }

  &__link {
    position: absolute;
    left: 22px;
    bottom: 22px;

    display: none;

    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }

  &--active &__link {
    display: block;
  }

  &__tip-wrapper {
    position: absolute;
    right: 22px;
    bottom: 22px;
  }

  &__tip {
    width: 28px;
    height: 28px;

    background-color: #fff;
    border-radius: 50%;

    cursor: pointer;
  }

  &--profile &__tip {
    display: none;
  }

  &--profile &__tip-wrapper {
    display: none;
  }

  &--profile .switch {
    display: none;
  }

  @media #{$mobile} {
    max-width: 400px;
  }
}

.switch {
  position: relative;

  width: 48px;

  cursor: pointer;

  &__thumb {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;

    width: 28px;
    height: 28px;

    background-color: #fff;
    box-shadow: 0px 2.8px 2.8px rgba(0, 0, 0, 0.24),
      0px 0px 2.8px rgba(0, 0, 0, 0.12);

    border-radius: 50%;
  }

  &__track {
    position: absolute;
    left: 0;
    top: 0;

    width: 48px;
    height: 28px;

    border-radius: 14px;

    background-color: #26cc72;
  }

  &.is-checked &__track {
    background-color: #19a95b;
  }

  &.is-checked &__thumb {
    transform: translateX(20px);
  }
}
</style>
